export default (function () {
  return Date.now();
});